/**
 * スタッフ招待ページ専用i18n定数
 */

export const STAFF_INVITATION_I18N = {
  // ページタイトル
  title: {
    staffInvite: $localize`:@@admin.staffInvitation.title.staffInvite:スタッフの招待`,
    contributorInvite: $localize`:@@admin.staffInvitation.title.contributorInvite:多職種スタッフの招待`,
    listSuffix: $localize`:@@admin.staffInvitation.title.listSuffix:一覧`,
  },

  // バックリンク
  backLink: {
    staffList: $localize`:@@admin.staffInvitation.backLink.staffList:スタッフ`,
    contributorList: $localize`:@@admin.staffInvitation.backLink.contributorList:多職種スタッフ`,
  },

  // フォーム文言
  placeholder: {
    jobTitle: $localize`:@@adminSection.staffInvitation.placeholder.jobTitle:職種を選択してください`,
    noUser: $localize`:@@adminSection.staffInvitation.placeholder.noUser:指定しない`,
  },
  label: {
    optional: $localize`:@@adminSection.staffInvitation.label.optional:（任意）`,
  },
  description: {
    accountManagement: $localize`:@@adminSection.staffInvitation.description.accountManagement:スタッフの追加・編集・削除が可能`,
    userManagement: $localize`:@@adminSection.staffInvitation.description.userManagement:ユーザーの追加・編集・削除が可能`,
  },
  option: {
    noUser: $localize`:@@adminSection.staffInvitation.option.noUser:指定しない`,
  },

  // ステータス
  status: {
    active: $localize`:@@admin.staffInvitation.status.active:有効`,
    inactive: $localize`:@@admin.staffInvitation.status.inactive:無効`,
  },

  // アカウントグループ
  accountGroup: {
    staff: $localize`:@@admin.staffInvitation.accountGroup.staff:スタッフ`,
    user: $localize`:@@admin.staffInvitation.accountGroup.user:ユーザー`,
  },

  // バリデーションメッセージ
  validation: {
    emailRequired: $localize`:@@admin.staffInvitation.validation.emailRequired:　メールアドレスの入力は必須です`,
    emailInvalid: $localize`:@@admin.staffInvitation.validation.emailInvalid:メールアドレスを正しい形式で入力してください`,
    jobTitleRequired: $localize`:@@admin.staffInvitation.validation.jobTitleRequired:　役職を選択してください`,
  },

  // ボタン
  button: {
    close: $localize`:@@admin.staffInvitation.button.close:閉じる`,
  },

  // メッセージ
  message: {
    inviteSuccess: $localize`:@@admin.staffInvitation.message.inviteSuccess:招待メールの送信が完了しました。`,
    inviteError: $localize`:@@admin.staffInvitation.message.inviteError:招待メールの送信に失敗しました。再度お試しください。`,
  },
} as const;

export type StaffInvitationI18n = typeof STAFF_INVITATION_I18N;
